/// <reference path="wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Utilities;
    (function (Utilities) {
        const LOG_CATEGORY = "WPT.UserSettingsHelper";
        class UserSettingsHelper {
            constructor(core) {
                this._log = null;
                // UI Handling
                this._modalSession = null;
                this._themeInput = null;
                this._sections = [];
                // Data
                this._themeList = null;
                this.showSettingsDialog = () => {
                    this._log.info("UserSettingsHelper::showSettingsDialog");
                    this._modalSession = 'user-settings-' + performance.now();
                    let modal = this._core.requestModal(WPTNamespace.ModalType.FIRST, this._modalSession);
                    if (modal !== null && modal !== undefined) {
                        if (UserSettingsHelper.HtmlData === null) {
                            this._core.Loader.getVersionedHTML("assets/wpt/html/userSettings.html", this._storeDialogHtml, this._core.Helper.missingHtmlErrorCallback);
                        }
                        else {
                            this._presentUserSettings();
                        }
                    }
                    else {
                        console.error("Unable to show user settings modal, modal placeholder is already in use.");
                    }
                };
                this._storeDialogHtml = (htmlData) => {
                    this._log.info("UserSettingsHelper._storeDialogHtml()");
                    UserSettingsHelper.HtmlData = htmlData;
                    this._presentUserSettings();
                };
                this._presentUserSettings = () => {
                    this._log.info("UserSettingsHelper._presentUserSettings()");
                    this._sections = ['change-password'];
                    let modal = this._core.getModal(this._modalSession);
                    modal.DIV.innerHTML = UserSettingsHelper.HtmlData;
                    this._presentThemeSection(modal);
                    // Captions
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#userSettingsModalTitle'), 'STR_WPT_USERSETTINGS');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#applyChangesButtonLabel'), 'STR_WPT_APPLY');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#cancelChangesButtonLabel'), 'STR_WPT_CANCEL');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#requestChangePwButtonLabel'), 'STR_WPT_CHANGEPASSWORD');
                    // Events
                    modal.DIV.querySelector('#applyChangesButton').addEventListener('click', this._applyChanges);
                    modal.DIV.querySelector('#cancelChangesButton').addEventListener('click', this._cancelChanges);
                    modal.DIV.querySelector('#requestChangePwButton').addEventListener('click', this._changePasswordRequested);
                    // We might actually have no sessions
                    if (this._sections.length > 1)
                        this._core.Functions.showElement(modal.DIV.querySelector('#applyCancelButtonContainer'));
                    this._core.showModal(this._modalSession);
                };
                this._presentThemeSection = (modal) => {
                    this._log.info("UserSettingsHelper._presentThemeSection()");
                    if (!this._core.serviceAvailable('userprofiles') || (this._themeList.length == 0))
                        return;
                    // Find content and set options
                    let themeSelectDiv = modal.DIV.querySelector('#userSettingsThemeSelectHolder');
                    this._core.Helper.setElementTranslation(modal.DIV.querySelector('#userSettingsThemeSelectLabel'), 'STR_WPT_DEFAULTTHEME');
                    // Build up the settings we need
                    let themeOptions = {
                        Items: []
                    };
                    this._themeList.forEach(theme => {
                        themeOptions.Items.push({ Id: theme.Name, DisplayName: this._core.Locale.getTranslation(theme.Label) });
                    });
                    let optionConfig = {
                        Options: themeOptions,
                        ValueMustExist: true,
                        AllowEmptyValue: true,
                        ChangeCallback: null
                    };
                    this._themeInput = new WPTNamespace.Widgets.ComponentOptionInput(this._core, themeSelectDiv, null, optionConfig);
                    this._themeInput.present();
                    this._themeInput.Input.id = "userSettingsThemeSelect";
                    let themeSetting = `Theme:${this._core.Config.getMainConfig().InstanceName}|${WPTNamespace.DEFAULT_THEME_TAG}`.toUpperCase();
                    let currentThemeId = this._core.GetUserProfileConfigVar(themeSetting);
                    if (currentThemeId) {
                        let currentTheme = this._themeList.find(t => (t.Name == currentThemeId));
                        if (currentTheme) {
                            this._themeInput.Input.value = this._core.Locale.getTranslation(currentTheme.Label);
                            this._themeInput.Input.dispatchEvent(new Event('change'));
                        }
                    }
                    this._core.Functions.showElement(modal.DIV.querySelector('#userSettingsThemeSection'));
                    this._sections.push('default-theme');
                };
                this._changePasswordRequested = (event) => {
                    this._log.info("UserSettingsHelper._changePasswordRequested()");
                    let modal = this._core.getModal(this._modalSession);
                    let menu = this._core.Navigation.Menu;
                    modal.JQ.one('hidden.bs.modal', function () {
                        menu.showChangePw();
                    });
                    this._core.hideAndClearModal(this._modalSession);
                    this._modalSession = null;
                };
                this._applyChanges = (event) => {
                    this._log.info("UserSettingsHelper._applyChanges()");
                    // Apply sections as they are enabled
                    if (this._sections.indexOf('default-theme') > -1) {
                        let themeSetting = `Theme:${this._core.Config.getMainConfig().InstanceName}|${WPTNamespace.DEFAULT_THEME_TAG}`.toUpperCase();
                        if (this._themeInput.LastSelectedOption)
                            this._core.SetUserProfileConfigVar(themeSetting, this._themeInput.LastSelectedOption.Id);
                        else
                            this._core.SetUserProfileConfigVar(themeSetting, null);
                        let themeRequested = this._core.Helper.requestTheme();
                        if (!themeRequested)
                            this._core.Loader.resetCSS(this._core.Config.getSelectedApplication().CSS, false);
                    }
                    this._core.hideAndClearModal(this._modalSession);
                    this._modalSession = null;
                };
                this._cancelChanges = (event) => {
                    this._log.info("UserSettingsHelper._cancelChanges()");
                    this._core.hideAndClearModal(this._modalSession);
                    this._modalSession = null;
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("UserSettingsHelper::constructor");
                let mainConfig = this._core.Config.getMainConfig();
                if (mainConfig.hasOwnProperty('Themes') && mainConfig.Themes)
                    this._themeList = mainConfig.Themes;
                else
                    this._themeList = [];
            }
        }
        UserSettingsHelper.HtmlData = null;
        Utilities.UserSettingsHelper = UserSettingsHelper;
    })(Utilities = WPTNamespace.Utilities || (WPTNamespace.Utilities = {}));
})(WPTNamespace || (WPTNamespace = {}));
